import { CategoryTypes } from '../enums/categoryTypes';
import { ProductTypes } from '../enums/productTypes';
import { RevenueTypes } from '../enums/revenueTypes';

export class Product {
    name: string;

    /** Actual price included discounts */
    price: string;
    coupon: string;
    id: string;

    category: string;
    quantity: number;

    /** Product type */
    dimension1: string;

    /** Original price without discounts */
    dimension2: string;

    /** Discount amount */
    dimension3: string;

    /** Subscription type */
    dimension9: string;

    /** Revenue type */
    dimension10: string;

    public setName(name: string): Product {
        this.name = name;
        return this;
    }

    public setId(id: string): Product {
        this.id = id;
        return this;
    }

    public setPrice(price: number): Product {
        this.price = price.toString();
        this.dimension2 = price.toString();
        this.dimension3 = '0';
        return this;
    }

    public setCategory(category: string): Product {
        this.category = category;

        /* */
        if (category === CategoryTypes.Package || category === CategoryTypes.AccessCard || category === CategoryTypes.Trial) {
            this.dimension1 = ProductTypes.Service;
            this.dimension10 = RevenueTypes.Subscription;
        } else {
            this.dimension1 = ProductTypes.Product;
            this.dimension10 = RevenueTypes.OneTime;
        }
        return this;
    }

    public setTerm(term: string): Product {
        this.dimension9 = `sub${term}`;
        return this;
    }

    /**
     *
     * @param term Replace 'term' text-value completly
     * @returns
     */
    public setTermText(term: string): Product {
        this.dimension9 = term;
        return this;
    }

    public applyDiscount(amount: number): Product {
        this.dimension3 = amount.toString();
        this.price = (Number(this.dimension2) - amount).toString();
        return this;
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/ecommerce/models/ecommerceProduct.ts